$(() => {
  const pagers_in_use = () => {
    const nurses_on_staff = parseInt($('#nurses-on-staff').val().replace(',', ''), 10);
    const physicians_on_staff = parseInt($('#physicians-on-staff').val().replace(',', ''), 10);

    return Math.round(0.7 * (nurses_on_staff + physicians_on_staff));
  };

  const run = () => {
    if ($('#pagers-in-use-overridden').val() === '0') {
      $('#pagers-in-use').val(pagers_in_use());
    }
  };

  run();

  $('#nurses-on-staff, #physicians-on-staff').change(() => {
    run();
  });

  $('#nurses-on-staff, #physicians-on-staff').blur(() => {
    run();
  });

  $('#pagers-in-use').blur(() => {
    $('#pagers-in-use-overridden').val('1');
  });
});
